import { useTranslation } from 'react-i18next';
import { Button } from '@monecolier/ui';
import { setLocale, SUPPORTED_LOCALES, type SupportedLocale } from '../i18n';

// PAR-15 — sélecteur de langue, pied de la Sidebar (nouveau slot additif
// `footerExtra`, `packages/ui/src/Sidebar.tsx` — voir son commentaire pour la
// raison de ce choix d'emplacement). Réutilise `Button` (`packages/ui`) TEL
// QUEL, aucun nouveau composant/style inventé pour ce ticket.
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = i18n.language as SupportedLocale;

  return (
    <div className="flex items-center justify-between px-3 py-1" data-testid="language-switcher">
      <span className="text-xs font-medium text-gray-500">{t('language.label')}</span>
      <div className="flex gap-1">
        {SUPPORTED_LOCALES.map((locale) => (
          <Button
            key={locale}
            type="button"
            size="small"
            variant={current === locale ? 'primary' : 'secondary'}
            aria-pressed={current === locale}
            onClick={() => setLocale(locale)}
            data-testid={`language-switcher-${locale}`}
          >
            {t(`language.${locale}`)}
          </Button>
        ))}
      </div>
    </div>
  );
}
